module.exports = __webpack_public_path__ + "static/media/img1-2.7a52bd40.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/biosense/diff/img1-2.png
// module id = 2189
// module chunks = 3